import React from "react";
export default function AboutSection(props) {
  const about_txt = (
    <>
      <h1 className="black-text">An introduction about Ali Najafzadeh</h1>
      <p className="black-text">
        Hello there! I'm Ali, a bachelor's degree graduate in Computer Science
        from Amir Kabir University, Tehran, Iran.
        <br />
        Over the past four years the majority of my time has been dedicated to
        improving my web skills. My passion for front-end development was first
        ignited with learning JavaScript and I am now very eager to expand my
        knowledge to mobile platforms as well whilst I explore further with
        React Native.
        <br />
        My programming journey started with Pascal Language, a simple yet
        effective gateway to learning programming. Following that I was able to
        master C# and Delphi which in turn familiarized me with Object Oriented
        Programming (OOP) concepts. I was also able to broaden my expertise in
        database knowledge by working with SQL server.
        <br />
        Along the way I have also dabbled in Windows Phone and Android, which
        proved to be a valuable experience although not my priority in my
        learning journey. At this stage the allure of web design encouraged me
        to start by learning WordPress. Recognizing the importance of
        establishing a strong knowledge foundation, I challenged myself to learn
        everything I could about web development from scratch. This led me to
        study HTML, CSS, JavaScript, JQuery, Sass, and, ultimately, React.js and
        Redux.
        <br />
        Throughout these learning experiences, I maintained an open mind and
        delved into concepts of mobile and web design. This included exploring
        Adobe XD, Unit Testing, and various other subjects.
      </p>
    </>
  );
  return (
    <div className="about-section">
      <div className="about-content">
        <div className="about-text">{about_txt}</div>
      </div>
    </div>
  );
}
